<template>
  <div>
    <vxe-card size="mini" width="100%">
      <div slot="title">
        <vxe-button content="tab.details" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </div>
      <template #extra>
        <vxe-button content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
        <vxe-button content="button.scanSupervisorCode" icon="vxe-icon-check" mode="text" status="warning" @click="supervise"/>
      </template>
      <vxe-row size="medium">
        <vxe-col span="4">
          <vxe-tip :content="order.no" :title="refundable?$t('business.label.returnOrderNo'):$t('business.label.receiptOrderNo')" status="error"/>
        </vxe-col>
        <vxe-col span="4">
          <vxe-tip :content="order.orderType.name" :title="refundable?$t('business.label.returnType'):$t('business.label.orderType')" status="primary"/>
        </vxe-col>
        <vxe-col span="4">
          <vxe-tip :title="$t('business.label.orderStatus')" status="primary">
            <template #default>
              <vxe-select v-model="order.orderStatus" :options="orderStatus" readonly/>
            </template>
          </vxe-tip>
        </vxe-col>
        <vxe-col span="4">
          <vxe-tip :content="order.storer.name" :title="$t('business.label.storerName')" status="primary"/>
        </vxe-col>
        <vxe-col span="4">
          <vxe-tip :content="order.customer.name" :title="refundable?$t('business.label.returnCustomer'):$t('business.label.supplier')" status="primary"/>
        </vxe-col>
        <vxe-col span="4">
          <vxe-tip :content="operator.name" :title="refundable?$t('business.label.returnOperator'):$t('business.label.receivingman')" status="primary"/>
        </vxe-col>
      </vxe-row>
      <vxe-row size="medium">
        <vxe-col span="16">
          <vxe-row size="medium">
            <vxe-col span="4">
              <vxe-tip :content="detail.item.no" :title="$t('business.label.itemNo')" status="primary"/>
            </vxe-col>
            <vxe-col span="8">
              <vxe-tip :content="detail.item.name" :title="$t('business.label.itemName')" status="error"/>
            </vxe-col>
            <vxe-col span="6">
              <vxe-tip :content="detail.lot.quality.qualityStandard" :title="$t('business.label.qualityStandard')" status="primary"/>
            </vxe-col>
            <vxe-col span="3">
              <vxe-tip :content="detail.item.legalAttribute.name" :title="$t('business.label.legalAttribute')" status="primary"/>
            </vxe-col>
            <vxe-col span="3">
              <vxe-tip :content="detail.item.dosageForm.name" :title="$t('business.label.dosageForm')" status="primary"/>
            </vxe-col>
          </vxe-row>
          <vxe-row size="medium">
            <vxe-col span="6">
              <vxe-tip :content="detail.pack.specification" :title="$t('business.label.specification')" status="error"/>
            </vxe-col>
            <vxe-col span="3">
              <vxe-tip :content="detail.pack.uom" :title="$t('business.label.uom')" status="error"/>
            </vxe-col>
            <vxe-col span="3">
              <vxe-tip :content="detail.pack.factor" :title="$t('business.label.factor')" status="primary"/>
            </vxe-col>
            <vxe-col span="6">
              <vxe-tip :content="detail.item.barcodes" :title="$t('business.label.itemBarcode')" status="error"/>
            </vxe-col>
            <vxe-col span="6">
              <vxe-tip :content="detail.item.permitHolder" :title="$t('business.label.permitHolder')" status="primary"/>
            </vxe-col>
          </vxe-row>
          <vxe-row size="medium">
            <vxe-col span="6">
              <vxe-tip :content="detail.lot.no" :title="$t('business.label.lot')" status="error"/>
            </vxe-col>
            <vxe-col span="3">
              <vxe-tip :content="detail.lot.productionDate" :title="$t('business.label.productionDate')" status="error"/>
            </vxe-col>
            <vxe-col span="3">
              <vxe-tip :content="detail.lot.validUntil" :title="$t('business.label.validUntil')" status="error"/>
            </vxe-col>
            <vxe-col span="4">
              <vxe-tip :content="summary.totalQuantity" :title="refundable?$t('business.label.returnTotalQuantity'):$t('business.label.receiptTotalQuantity')" status="error"/>
            </vxe-col>
            <vxe-col span="8">
              <vxe-tip :content="getStrings(storageRooms, 'name')" :title="$t('business.label.locationLimit')" status="primary"/>
            </vxe-col>
          </vxe-row>
          <vxe-row size="medium">
            <vxe-col span="12">
              <vxe-tip :content="detail.lot.manufacturer" :title="$t('business.label.manufacturer')" status="primary"/>
            </vxe-col>
            <vxe-col span="4">
              <vxe-tip :content="summary.unreceivedQuantity" :title="refundable?$t('business.label.unacceptedQuantity'):$t('business.label.unreceivedQuantity')" status="error"/>
            </vxe-col>
            <vxe-col span="4">
              <vxe-tip :content="summary.receivedQuantity" :title="refundable?$t('business.label.acceptedQuantity'):$t('business.label.receivedQuantity')" status="error"/>
            </vxe-col>
            <vxe-col span="4">
              <vxe-tip :content="summary.rejectedQuantity" :title="refundable?$t('business.label.rejectedQuantityOfReturn'):$t('business.label.rejectedQuantity')" status="error"/>
            </vxe-col>
          </vxe-row>
          <vxe-row size="medium">
            <vxe-col span="12">
              <vxe-tip :content="detail.lot.producingArea" :title="$t('business.label.producingArea')" status="primary"/>
            </vxe-col>
            <vxe-col span="12">
              <vxe-tip :content="detail.lot.approvalNo" :title="$t('business.label.approvalNo')" status="primary"/>
            </vxe-col>
          </vxe-row>
          <vxe-form :data="detail" border size="medium" span="8" title-align="center" title-background title-bold>
            <vxe-form-item field="receivedQuantity" title="business.label.quantity">
              <template #default>
                <vxe-number-input ref="receivedQuantity" v-model="detail.receivedQuantity" :max="summary.unreceivedQuantity-detail.rejectedQuantity" :min="0" clearable @change="onQuantityChange"/>
              </template>
            </vxe-form-item>
            <vxe-form-item field="numberOfFcl" title="business.label.cases">
              <template #default>
                <vxe-number-input v-model="detail.numberOfFcl" :disabled="summary.unreceivedQuantity<detail.pack.factor" :max="detail.pack.factor?Math.floor(summary.unreceivedQuantity/detail.pack.factor):0" :min="0" clearable @change="onCasesChange"/>
              </template>
            </vxe-form-item>
            <vxe-form-item :item-render="{name:'VxeInput',props:{clearable:false,editable:false}}" field="numberOfLcl" title="business.label.numberOfEach"/>
            <vxe-form-item field="storageRoom.id" title="business.label.inboundStorageRoom">
              <template #default>
                <vxe-select v-model="detail.storageRoom.id" :options="storageRooms" clearable/>
              </template>
            </vxe-form-item>
            <vxe-form-item field="container.no" title="business.label.containerNo">
              <template #default>
                <vxe-input v-model="detail.container.no" :editable="false" clearable @dblclick.native="onContainerSelect" @keydown.native.enter="onContainerSelect"/>
              </template>
            </vxe-form-item>
            <vxe-form-item v-if="refundable||detail.item.autoAccepting" field="receiptConclusion.id" title="business.label.receiptConclusion">
              <template #default>
                <vxe-select v-model="detail.receiptConclusion.id" :options="receiptConclusions" clearable/>
              </template>
            </vxe-form-item>
            <vxe-form-item field="rejectedQuantity" title="business.label.rejectedQuantity">
              <template #default>
                <vxe-number-input v-model="detail.rejectedQuantity" :max="summary.unreceivedQuantity-detail.receivedQuantity" :min="0" clearable @change="onRejectedQuantityChange"/>
              </template>
            </vxe-form-item>
            <vxe-form-item field="rejectedReason.id" title="business.label.rejectedReason">
              <template #default>
                <vxe-select v-model="detail.rejectedReason.id" :disabled="detail.rejectedQuantity===0" :options="rejectedReasons" clearable/>
              </template>
            </vxe-form-item>
            <vxe-form-item field="opinion.id" title="business.label.treatmentSuggestion">
              <template #default>
                <vxe-select v-model="detail.opinion.id" :disabled="detail.rejectedQuantity===0" :options="opinions" clearable/>
              </template>
            </vxe-form-item>
            <vxe-form-item field="notes" span="24" title="business.label.notes">
              <template #default>
                <vxe-textarea v-model="detail.notes" :auto-size="{ minRows: 5, maxRows: 7 }"/>
              </template>
            </vxe-form-item>
          </vxe-form>
        </vxe-col>
        <vxe-col span="8">
          <vxe-row size="medium">
            <vxe-col span="6">
              <vxe-tip :status="detail.item.valuable?'error':'info'" :title="$t('business.label.valuable')">
                <template #default>
                  <vxe-select v-model="detail.item.valuable" :options="options" readonly/>
                </template>
              </vxe-tip>
            </vxe-col>
            <vxe-col span="6">
              <vxe-tip :status="detail.item.special?'error':'info'" :title="$t('business.label.special')">
                <template #default>
                  <vxe-select v-model="detail.item.special" :options="options" readonly/>
                </template>
              </vxe-tip>
            </vxe-col>
            <vxe-col span="6">
              <vxe-tip :status="detail.item.fragile?'error':'info'" :title="$t('business.label.fragile')">
                <template #default>
                  <vxe-select v-model="detail.item.fragile" :options="options" readonly/>
                </template>
              </vxe-tip>
            </vxe-col>
            <vxe-col span="6">
              <vxe-tip :status="detail.item.supervised?'error':'info'" :title="$t('business.label.supervised')">
                <template #default>
                  <vxe-select v-model="detail.item.supervised" :options="options" readonly/>
                </template>
              </vxe-tip>
            </vxe-col>
          </vxe-row>
          <vxe-row size="medium">
            <vxe-col span="6">
              <vxe-tip :status="detail.item.autoAccepting?'error':'info'" :title="$t('business.label.autoAccepting')">
                <template #default>
                  <vxe-select v-model="detail.item.autoAccepting" :options="options" readonly/>
                </template>
              </vxe-tip>
            </vxe-col>
            <vxe-col span="6">
              <vxe-tip :status="detail.item.autoPutaway?'error':'info'" :title="$t('business.label.autoPutaway')">
                <template #default>
                  <vxe-select v-model="detail.item.autoPutaway" :options="options" readonly/>
                </template>
              </vxe-tip>
            </vxe-col>
            <vxe-col span="6">
              <vxe-tip :status="detail.item.scattered?'error':'info'" :title="$t('business.label.scattered')">
                <template #default>
                  <vxe-select v-model="detail.item.scattered" :options="options" readonly/>
                </template>
              </vxe-tip>
            </vxe-col>
            <vxe-col span="6">
              <vxe-tip :status="detail.item.visualized?'error':'info'" :title="$t('business.label.visualized')">
                <template #default>
                  <vxe-select v-model="detail.item.visualized" :options="options" readonly/>
                </template>
              </vxe-tip>
            </vxe-col>
          </vxe-row>
          <vxe-row size="medium">
            <vxe-image height="100px" src="@/assets/example.jpeg" width="100px"/>
          </vxe-row>
        </vxe-col>
      </vxe-row>
    </vxe-card>
    <container-modal ref="containerModal" @change="onContainerChange"/>
    <SupervisedModal ref="supervisedModal" :type="1"/>
  </div>
</template>
<script>
import api from '@/api'
import { post } from '@/api/Api'
import { BaseObject } from '@/api/dto/BaseObject'
import { AsnDetail, AsnOrder } from '@/api/dto/order/AsnOrder'
import { ReceiptDetail } from '@/api/dto/order/ReceiptOrder'
import { Dictionary } from '@/api/dto/admin/Dictionary'
import { Container } from '@/api/dto/common/Container'
import { Lot } from '@/api/dto/common/Lot'
import ContainerModal from '@/views/modal/ContainerModal.vue'
import SupervisedModal from '@/views/modal/SupervisedModal.vue'
import { formatSelect, getDictionaries, getStrings, getUser, getWarehouse } from '@/utils/util'
import { DeviceHandler } from '@/deviceHelper'

export default {
  name: 'ReceiptEdit',
  components: { ContainerModal, SupervisedModal },
  data() {
    return {
      loading: false,
      operator: getUser(),
      warehouse: getWarehouse(),
      row: {},
      order: new AsnOrder(),
      detail: new ReceiptDetail(),
      storageRooms: [],
      receiptConclusions: [],
      rejectedReasons: [],
      opinions: [],
      options: [
        { label: this.$t('business.label.true'), value: true },
        { label: this.$t('business.label.false'), value: false }
      ],
      summary: {
        totalQuantity: 0,
        receivedQuantity: 0,
        unreceivedQuantity: 0,
        rejectedQuantity: 0
      }
    }
  },
  created() {
    getDictionaries('REJECT_REASON').then(result => {
      this.rejectedReasons = result
      return getDictionaries('OPINION')
    }).then(result => {
      this.opinions = result
      return getDictionaries('RETURN_CONCLUSION')
    }).then(result => {
      this.receiptConclusions = result
    })
  },
  props: {
    refundable: {
      type: Boolean,
      default: false
    },
    orderStatus: {
      type: Array,
      default: []
    },
    storers: {
      type: Array,
      default: []
    }
  },
  methods: {
    getStrings,
    formatSelect,
    back() {
      this.$emit('back')
    },
    refresh(row) {
      this.row = row
      this.loading = true
      this.order = row.order
      const asnDetail = new AsnDetail(BaseObject.merge(row, 'asnDetail'))
      this.detail = new ReceiptDetail(asnDetail)
      this.detail.item.legalAttribute = new Dictionary(row.legalAttribute)
      this.detail.item.dosageForm = new Dictionary(row.dosageForm)
      this.detail.lot = new Lot(asnDetail.toJSONObject())
      this.detail.lot.no = asnDetail.lotNo
      this.detail.receivedQuantity = 0
      this.detail.rejectedQuantity = 0
      this.summary.totalQuantity = asnDetail.quantity
      this.summary.receivedQuantity = asnDetail.receivedQuantity
      this.summary.rejectedQuantity = asnDetail.rejectedQuantity
      this.summary.unreceivedQuantity = asnDetail.quantity - asnDetail.receivedQuantity - asnDetail.rejectedQuantity
      this.detail.numberOfFcl = 0
      this.detail.numberOfLcl = 0
      const args = {
        'query.no': 'limitStorageRoom',
        'sql': null,
        args: { whId: this.warehouse.id, itemId: this.detail.item.id }
      }
      post(api.adminQuery, {}, args).then(res => {
        if (res.success) {
          this.storageRooms = res.result.map(item => {
            return {
              value: item.id,
              label: item.name + '(' + item.limit + ')',
              name: item.name
            }
          })
        }
        this.$nextTick(() => this.$refs.receivedQuantity.focus())
      }).finally(() => this.loading = false)
    },
    clear() {
      this.clearOrder()
      this.clearDetail()
    },
    clearOrder() {
      this.order = new AsnOrder()
    },
    clearDetail() {
      this.detail = new ReceiptDetail()
      this.summary = {
        totalQuantity: 0,
        receivedQuantity: 0,
        unreceivedQuantity: 0,
        rejectedQuantity: 0
      }
      this.storageRooms = []
    },
    onQuantityChange({ value }) {
      if (value === null) this.$nextTick(() => this.detail.receivedQuantity = 0)
      if (this.detail.pack.factor) {
        this.detail.numberOfFcl = Math.floor(this.detail.receivedQuantity / this.detail.pack.factor)
        this.detail.numberOfLcl = this.detail.receivedQuantity % this.detail.pack.factor
      }
    },
    onCasesChange({ value }) {
      if (value === null) this.$nextTick(() => this.detail.numberOfFcl = 0)
      if (this.detail.pack.factor) {
        this.detail.receivedQuantity = this.detail.numberOfFcl * this.detail.pack.factor
        this.detail.numberOfLcl = 0
      }
    },
    onContainerSelect() {
      this.$refs.containerModal.open({ available: true, physical: true, 'storageRoom.id': this.detail.storageRoom.id })
    },
    onContainerChange(values) {
      this.detail.container = new Container(values[0])
    },
    onRejectedQuantityChange({ value }) {
      if (value === null) this.$nextTick(() => this.detail.rejectedQuantity = 0)
    },
    save() {
      if (this.order.isNew()) {
        return this.$warning({
          title: '缺少单据信息',
          centered: true,
          okText: '确定'
        })
      }
      if (this.detail.item.isNew()) {
        return this.$warning({
          title: '缺少商品信息',
          centered: true,
          okText: '确定'
        })
      }
      if (this.detail.receivedQuantity === 0 && this.detail.rejectedQuantity === 0) {
        return this.$warning({
          title: '数量与拒收数量不能同时为0',
          centered: true,
          okText: '确定'
        })
      }
      if (this.detail.rejectedQuantity > 0 && this.detail.rejectedReason.isNew()) {
        return this.$warning({
          title: '拒收数量大于0,请填写拒收原因',
          centered: true,
          okText: '确定'
        })
      }
      this.loading = true
      const args = {
        allocate: true,
        palletize: true,
        tag: false,
        generate: true,
        order: {
          ...this.order.toJSONObject(),
          warehouse: this.warehouse
        },
        details: [{
          ...this.detail.toJSONObject(),
          lot: this.detail.lot.toJSONObject(),
          invoiceQuantity: this.detail.receivedQuantity,
          receivingman: this.operator.name
        }]
      }
      post(api.receivingReceiverSave, { type: 'normalInboundReceiver' }, args).then(res => {
        if (res.success) {
          const that = this
          this.printData(res.result)
          this.$success({
            title: '保存成功',
            onOk() {
              if (that.detail.item.supervised) {
                that.supervise()
              } else {
                that.next()
              }
            },
            onCancel() {
              that.next()
            },
            centered: true
          })
        }
      }).finally(() => this.loading = false)
    },
    next() {
      this.summary.unreceivedQuantity = this.summary.unreceivedQuantity - this.detail.receivedQuantity - this.detail.rejectedQuantity
      if (this.summary.unreceivedQuantity === 0) {
        this.back()
      } else {
        this.row.asnDetail.receivedQuantity += this.detail.receivedQuantity
        this.row.asnDetail.rejectedQuantity += this.detail.rejectedQuantity
        this.clear()
        this.refresh(this.row)
      }
    },
    supervise() {
      const args = {
        'asnOrder.id': this.order.id,
        'item.no': this.detail.item.no,
        'lot.no': this.detail.lot.no
      }
      this.$refs.supervisedModal.open(args)
    },
    printData(data) {
      if (data.commandGroup === null || data.commandGroup === undefined) {
        return
      }
      const body1 = {
        'query.no': 'receivingCheckPrint',
        sql: null,
        args: {
          commandGroup: data.commandGroup
        }
      }
      post(api.adminQuery, {}, body1).then(res => {
        if (res.result.length > 0) {
          const Dt = []
          res.result.map(data => {
            data.zhxs = '入(' + parseInt(data.zhjs).toFixed(1) + '箱)'
            data.spmcgg = data.spmc + ' / ' + data.gg
            data.phxq = data.ph + ' / ' + data.xq
            data.sldw = '数量：' + data.sl + '(' + data.dw + ')'
            data.qyxx = data.qy + ' / ' + data.lc + data.zs + ' / ' + data.spbh
            data.dhrq = data.asnNo + ' / ' + data.scrq
            data.bdm = data.pzwh + '箱数量：' + parseInt(data.bzs).toFixed(1) + ' / ' + data.fdsx
            Dt.push(data)
          })
          if (Dt.length > 0) {
            const printList = []
            printList.push(
              {
                'PLAN_CODE': '080027',
                'WH_ID': 1000000001,
                'DATA': Dt
              }
            )
            DeviceHandler.printWithDataList(printList, (q, res) => {
              post(api.receivingReceiverPrintUpdate, {}, { commandGroup: data.commandGroup })
            })
          }
        } else {
          this.$message.warning('无可打印数据')
        }
      })
    }
  }
}
</script>